import { render, staticRenderFns } from "./issue-add-or-update.vue?vue&type=template&id=03d5e0b0&"
import script from "./issue-add-or-update.vue?vue&type=script&lang=js&"
export * from "./issue-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports